<template>
  <div>
    <simc-picker :model="schema" :field="simcField" :terc="schema.terc.$value" />

    <ulic-picker
      :disabled="disabled"
      :model="schema"
      :field="ulicField"
      :terc="schema.terc.$value"
      :simc="schema.simc.$value"
      :city="schema.city.$value"
    />
  </div>
</template>

<script>
import SimcPicker from './SIMCPicker';
import UlicPicker from './ULICPicker';

// @vuese
// Komponent formularza TERYT
// @group Forms
export default {
  components: { SimcPicker, UlicPicker },
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Nazwa pola z TERC-em
    tercField: {
      type: String,
      required: false,
      default: 'terc'
    },
    // Nazwa pola z SIMC-em
    simcField: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Nazwa pola z ULIC-em
    ulicField: {
      type: String,
      required: false,
      default: 'ulic'
    },
    // Czy pola mają być ustawione rzędami
    row: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy pola mają być disabled
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
